import React from 'react';
import './LandingAnim.scss';

// import grid1 from '../images/grid_layout/grid1.JPG';
// import grid2 from '../images/grid_layout/grid2.JPG';
// import grid3 from '../images/grid_layout/grid3.JPG';
// import grid4 from '../images/grid_layout/grid4.JPG';
// import grid5 from '../images/grid_layout/grid5.jpg';
// import grid6 from '../images/grid_layout/grid6.JPG';
// import grid7 from '../images/grid_layout/grid7.JPG';
// import grid8 from '../images/grid_layout/grid8.JPG';
// import grid9 from '../images/grid_layout/grid9.jpg';
// import grid10 from '../images/grid_layout/grid10.JPG';
// import grid11 from '../images/grid_layout/grid11.JPG';
// import grid12 from '../images/grid_layout/grid12.JPG';
// import grid13 from '../images/grid_layout/grid13.JPG';
// import grid14 from '../images/grid_layout/grid14.JPG';
// import grid15 from '../images/grid_layout/grid15.jpeg';
// import grid16 from '../images/grid_layout/grid16.JPG';

import grid1 from '../images/grid_layout/grid1.png';
import grid2 from '../images/grid_layout/grid2.png';
import grid3 from '../images/grid_layout/grid3.png';
import grid4 from '../images/grid_layout/grid4.png';
import grid5 from '../images/grid_layout/grid5.png';
import grid6 from '../images/grid_layout/grid6.png';
import grid7 from '../images/grid_layout/grid7.png';
import grid8 from '../images/grid_layout/grid8.png';
import grid9 from '../images/grid_layout/grid9.png';
import grid10 from '../images/grid_layout/grid10.png';
import grid11 from '../images/grid_layout/grid11.png';
import grid12 from '../images/grid_layout/grid12.png';
import grid13 from '../images/grid_layout/grid13.png';
import grid14 from '../images/grid_layout/grid14.png';
import grid15 from '../images/grid_layout/grid15.png';
import grid16 from '../images/grid_layout/grid16.png';

const images = [
  grid1,
  grid2,
  grid3,
  grid4,
  grid5,
  grid6,
  grid7,
  grid8,
  grid9,
  grid10,
  grid11,
  grid12,
  grid13,
  grid14,
  grid15,
  grid16
];

const GraduationIssue = (props) => {

  return (
    <div className="grad-Issue">
    <div className="grid-container">
      {images.map((image, index) => (
        <div key={index} className="grid-item">
          <img src={image} alt={`${index + 1}`} />
        </div>
      ))}
      <div className="text-overlay">
        <div className="overlay-box">
          <div className="grad-title">
            <h1>GRADUATION ISSUE</h1>
          </div>
          <div className='grad-year'>
            <h2>
              <em>2</em>
              <em>0</em>
              <em>2</em>
              <em>4</em>
            </h2>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default GraduationIssue;
